import * as actionTypes from './actionTypes';
import { serviceValidationTokenEmail } from './services';
import { openModal } from '@app/src/commons/modal/state/modals/actions';

const fetchValidationTokenEmailRequest = () => ({
  type: actionTypes.FETCH_VALIDATION_TOKEN_REQUEST
});

const fetchValidationTokenEmailFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_VALIDATION_TOKEN_FAILURE,
  errorMessage
});

const fetchValidationTokenEmailSuccess = (data) => ({
  type: actionTypes.FETCH_VALIDATION_TOKEN_SUCCESS,
  data
});

export const fetchValidationTokenEmail = (url: string): Function => {
  return async dispatch => {
    dispatch(fetchValidationTokenEmailRequest());
    try {
      const data = await serviceValidationTokenEmail.getData(url);
      dispatch(fetchValidationTokenEmailSuccess(data));
    } catch(e) {
      dispatch(fetchValidationTokenEmailFailure(e.message));
      dispatch(openModal('TOKEN_EXPIRED'));
    }
  }
};
